<template>
  <div class="container">
    <div
      id="posterHtml"
      class='img-bg'
    >
      <div class="post">
        <div class="p-pic"><img
            :class="[isBigScreen?'p-pic-big':'']"
            :src="detail.pictureUrl"
            crossorigin='anonymous'
          ></div>
        <div class="p-content">
          <h3>{{detail.title}}</h3>
          <div class="p-info">
            <p
              class="p-des"
              :class="[isBigScreen?'p-des-big':'']"
            >
              {{detailInfo}}
            </p>
          </div>
          <div
            class="p-code"
            :class="[isBigScreen?'p-code-big':'']"
            id="posterHtml"
          >
            <img
              :src="wechatCode"
              @load='imgLoad'
              @error="imgError"
              crossorigin='anonymous'
            >
            <!-- <img src="http://api.video.winshang.com/video/0562298042.png" @load='imgLoad'  @error="imgError" crossorigin='anonymous'> -->
            <div>
              <p>长按扫码观看</p>
              <p class='p-text'>赢商video</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="player"
      v-if="isPlay"
      id="player"
    >
    </div>
    <div
      class="cover"
      v-else
    >
      <img :src='detail.pictureUrl'>
    </div>
    <div
      class="try-btn"
      @click="tryPlay"
      v-if="showTry"
    >
      <div class="outter"></div>
    </div>
    <div class="content">
      <div class="title"><span>{{detail.title}}</span></div>
      <div class="share">
        <div
          class="collect"
          @click="collectHandle"
        ><span class="share-collect"></span>{{isCollect?"已收藏":'收藏'}}</div>
        <div @click="shareFriendCircle"><span class="share-friend-circle"></span>分享朋友圈</div>
        <div @click="shareFriend"><span class="share-friend"></span>分享朋友</div>
      </div>
      <!-- <div class="video-info" ref="name">
      {{detail.describe}}
      </div> -->
      <van-tabs
        v-model="active"
        color="#FC9B18"
      >
        <van-tab title="直播">
          <div class="scroll-box">
            <div
              class="live-box"
              ref="list"
            >
              <div class="steps">
                <div class="van-steps__items">
                  <div
                    class="van-hairline van-step van-step--vertical van-step--process"
                    v-for="(item,index) in list"
                    :key="index"
                  >
                    <div
                      class="van-step__title van-step__title--active"
                      style="color: rgb(252, 155, 24);"
                    >
                      <div class="live-content">
                        <div class="live-time">{{changeTime(item.addTime)}}</div>
                        <div
                          class="live-detail"
                          @click="showImage($event)"
                        >
                          <div v-html="item.content">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="van-step__circle-container">
                      <i
                        class="van-icon van-icon-checked van-step__icon van-step__icon--active"
                        style="color: rgb(252, 155, 24);"
                      >
                      </i>
                    </div>
                    <div class="van-step__line"></div>
                  </div>
                </div>
              </div>
              <!-- <div v-for="item in list" :key="item.addTime">
                <div v-html="item.content"></div>
              </div> -->
              <!-- <van-steps direction="vertical" active-color="#FC9B18">
              <van-step v-for="item in list" :key="item.addTime">
                <div class="live-content">
                  <div class="live-time">{{changeTime(item.addTime)}}</div>
                  <div class="live-detail" >
                    <div v-html="item.content"></div>
                  </div>
                </div>
              </van-step>
            </van-steps> -->
            </div>
          </div>
        </van-tab>
        <van-tab title="互动">
          <div class="scroll-box">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="c-detail"
                v-for="item in messageList"
                ref="message"
                :key='item.sendTime'
              >
                <div class="c-pic"><img :src="item.headPortraits"></div>
                <div class="c-info">
                  <div class="c-name">
                    <span>{{item.userName}}</span>
                    <span class="c-time">{{changeTime(item.sendTime)}}</span>
                  </div>
                  <div class="c-comment">
                    {{item.content}}
                  </div>
                </div>
              </div>
            </van-list>
            <div class="send-box"><input
                type="text"
                v-model.trim="message"
                @blur="blurFuc"
              ><span
                class="send-message"
                @click="sendMessage"
              >发送</span></div>
          </div>
        </van-tab>
        <van-tab title="详情">
          <div class="scroll-box">
            <p class="detail-info">
              {{detail.describe}}
            </p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 显示图片层 -->
    <div
      class="picture-view"
      v-if='showPicture'
    >
      <span
        class="close-btn"
        @click="showPicture=false"
      ></span>
      <div
        @click="tabClick"
        @touchstart='touchstart'
        @touchend='touchend'
      >
        <img :src="pic">
      </div>
      <div class="picture-tip">
        <span>长按保存图片，可在朋友圈发布</span>
      </div>
    </div>
  </div>
</template>
<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import Aliplayer from 'Aliplayer' // 引入阿里的播放器
import html2canvas from 'html2canvas'
import { ImagePreview } from 'vant'
const DETAIL_PAGE_PATH = 'pages/live/detail'
const API_PATH = 'http://api.video.winshang.com'
export default {
  components: {
  },
  data () {
    return {
      showPicture: false,
      timer: null,
      error: false,
      hasClick: false,
      pageNum: 1,
      pageSize: 8,
      loading: false,
      finished: false,
      showTry: false,
      active: 0,
      isPlay: false,
      time: 3 * 1000,
      openId: '',
      id: '49',
      detail: {},
      isCollect: false,
      list: [],
      isLive: false,
      videoUrl: '',
      userImg: '',
      userName: '',
      messageList: [],
      message: '',
      height: '',
      wechatCode: '',
      pic: '',
      detailInfo: '',
      liveDis: [
        { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
        { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
        { name: 'infoDisplay', align: 'cc' },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            { name: 'liveDisplay', align: 'tlabs', x: 15, y: 6 },
            { name: 'fullScreenButton', align: 'tr', x: 10, y: 10 }
            // { name: 'subtitle', align: 'tr', x: 15, y: 12 },
            // { name: 'setting', align: 'tr', x: 15, y: 12 },
            // { name: 'volume', align: 'tr', x: 5, y: 10 }
          ]
        }
      ],
      videoDis: [
        { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
        {
          name: 'H5Loading', align: 'cc'
        },
        { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
        { name: 'infoDisplay' },
        { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
        { name: 'thumbnail' },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            { name: 'progress', align: 'blabs', x: 0, y: 30 },
            { name: 'playButton', align: 'tl', x: 15, y: 12 },
            { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
            { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 }
            // {name:"subtitle", align:"tr",x:15, y:12},
            // {name:"setting", align:"tr",x:15, y:12},
            // { name: 'volume', align: 'tr', x: 5, y: 10 }
          ]
        }
      ],
      isBigScreen: false
    }
  },
  mounted () {
    if (screen.height >= 800) {
      this.isBigScreen = true
    } else {
      this.isBigScreen = false
    }
    let detail = JSON.parse(decodeURIComponent(this.$route.query.data))
    this.id = detail.id
    this.title = detail.title
    this.openId = detail.openId
    this.userImg = detail.userImg
    this.userName = detail.userName
    this.getDeatail()
    this.getMessage()
    this.initWebSocket()
    // this.$fetch({
    //   methods: 'GET',
    //   url: '/video/appletCode',
    //   params: {
    //     path: DETAIL_PAGE_PATH,
    //     scene: this.id,
    //     width: 218
    //   }
    // })
    //   .then(response => {
    //     if (response.code === 0) {
    //       this.wechatCode = API_PATH + response.data
    //     }
    //   })
  },
  methods: {
    // 简单处理ios 键盘顶上去不下来的情况
    blurFuc () {
      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    onLoad () {
      this.pageNum++
      this.getMessage()
    },
    tryPlay () {
      if (this.player) {
        this.player.dispose()
        this.initPlayer()
        this.showTry = false
      }
    },
    initWebSocket () {
      this.connection()
      // let that = this
      // // 断开重连机制,尝试发送消息,捕获异常发生时重连
      // this.timer = setInterval(() => {
      //   try {
      //     that.stompClient.send()
      //   } catch (err) {
      //     console.log('断线了: ' + err)
      //     that.connection()
      //   }
      // }, 5000)
    },
    connection () {
      let that = this
      // 建立连接对象
      let socket = new SockJS('https://api.video.winshang.com/websocketVideo')
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket)
      // 定义客户端的认证信息,按需求配置
      // 向服务器发起websocket连接
      this.stompClient.connect({}, () => {
        that.stompClient.subscribe('/reception/message', (msg) => { // 订阅服务端提供的某个topic
          that.$fetch({
            method: 'POST',
            url: '/video/videoLiveParticulars',
            data: {
              id: that.id,
              openId: that.openId
            }
          }).then((res) => {
            that.list = res.data.backstageRecommen
          })
        })
        that.stompClient.subscribe('/reception/video', (msg) => { // 订阅服务端提供的某个topic
          let data = JSON.parse(msg.body)
          if (data.code === 0) {
            if (Number(data.data.videoId) === Number(that.id)) {
              that.messageList = [data.data].concat(that.messageList)
            }
          }
        })
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log(err)
      })
    }, // 连接 后台
    disconnect () {
      if (this.stompClient) {
        this.stompClient.disconnect()
      }
    }, // 断开连接
    // 发送信息
    sendMessage () {
      if (!this.message) {
        this.$toast('不能为空')
        return
      }
      if (this.stompClient) {
        this.stompClient.send('/deliver/send',
          {},
          JSON.stringify({
            openId: this.openId,
            videoId: this.id,
            content: this.message,
            sendTime: new Date().getTime(),
            userName: this.userName,
            headPortraits: this.userImg
          })
        ) // 用户加入接口
        this.message = ''
      }
    },
    // 添加已经看过的视频
    addWatchVideo () {
      this.$fetch.post('/video/addReadVideo', {
        videoId: this.id,
        openId: this.openId
      })
        .then(response => { })
    },
    // 获取详情
    getDeatail () {
      this.$fetch({
        method: 'POST',
        url: '/video/videoLiveParticulars',
        data: {
          id: this.id,
          openId: this.openId
        }
      }).then((res) => {
        this.addWatchVideo()
        this.detail = res.data.liveParticulars
        this.list = res.data.backstageRecommen
        this.isCollect = this.detail.isFavorites
        // 直播状态 1：预告 2：直播中 3：视频生成中 4：回播
        this.detailInfo = this.detail.describe
        if (this.detail.describe.length > 60 && !this.isBigScreen) {
          this.detailInfo = this.detail.describe.substr(0, 58) + '...'
        }
        if (this.detail.describe.length > 135 && this.isBigScreen) {
          this.detailInfo = this.detail.describe.substr(0, 135) + '...'
        }
        let type = this.detail.type
        if (type === 1) {
          // this.$toast('直播尚未开始')
          this.isPlay = false
        } else if (type === 2) {
          this.videoUrl = this.detail.videoUrl
          this.isLive = true
          this.isPlay = true
          this.$nextTick(() => {
            this.initPlayer()
          })
        } else if (type === 3) {
          // this.$toast('直播已结束')
          this.isPlay = false
        } else if (type === 4) {
          this.videoUrl = this.detail.videoUrl
          this.isLive = false
          this.isPlay = true
          this.$nextTick(() => {
            this.initPlayer()
          })
        } else if (type === 5) {
          this.videoUrl = this.detail.videoUrl
          this.isLive = true
          this.isPlay = true
          this.$nextTick(() => {
            this.initPlayer()
          })
        }
      })
    },
    initPlayer () {
      let that = this
      this.player = new Aliplayer({
        'id': 'player',
        'source': that.videoUrl, // 视频地址，支持mp4、m3u8
        'width': '100%',
        'height': '225px',
        'autoplay': true,
        'isLive': that.isLive,
        'rePlay': false,
        'playsinline': true,
        'preload': true,
        // 'controlBarVisibility': 'click’',
        // 'showBarTime':5000,
        'useH5Prism': true,
        'x5_type': true,
        'cover': that.detail.pictureUrl,
        'diagnosisButtonVisible': false,
        'skinLayout': that.isLive ? that.liveDis : that.videoDis,
        'liveRetry': 3,
        'x5_orientation': 'landscape',
        components: [{
          name: 'RateComponent',
          type: AliPlayerComponent.RateComponent
        }]
      }, function (player) {
        // 断流事件
        player.on('liveStreamStop', () => {
          document.querySelector('.prism-cover').style.display = 'block'
          document.querySelector('.prism-big-play-btn').style.display = 'block'
        })
        player.on('play', () => {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          document.querySelector('.prism-controlbar').style.display = 'none'
        })
        player.on('ended', () => {
          document.querySelector('.prism-cover').style.display = 'block'
        })
        player.on('showBar', () => {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            document.querySelector('.prism-controlbar').style.display = 'none'
          }, 5000)
        })
        player.on('error', (e) => {
          // 隐藏错误信息，显示封面图和点击按钮
          document.querySelector('.prism-cover').style.display = 'block'
          that.showTry = true
          document.querySelector('.prism-big-play-btn').style.display = 'none'
          document.querySelector('.prism-ErrorMessage').style.display = 'none'
        })
      }
      )
      // console.log(player)
    },
    // 收藏事件，取消或者添加
    collectHandle () {
      if (this.isCollect) {
        // 取消收藏
        this.$fetch
          .post('/video/deleteFavorites', {
            videoId: this.id,
            openId: this.openId
          })
          .then(response => {
            this.isCollect = false
            this.$toast('已取消收藏！')
          })
      } else {
        this.$fetch
          .post('/video/addFavorites', {
            videoId: this.id,
            openId: this.openId
          })
          .then(response => {
            this.isCollect = true
            this.$toast('收藏成功！')
          })
      }
    },
    // 分享朋友
    shareFriend () {
      this.$toast('请点击右上角的●●●图标进行分享')
    },
    // 分享朋友圈
    shareFriendCircle () {
      this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
        duration: 0
      })
      // if (this.wechatCode && !this.pic) {
      //   this.createPoster()
      // } else {
      //   this.getcode()
      // }
      this.getcode()
    },
    changeTime (time) {
      return this.dayjs(time)
        .locale('zh-cn')
        .fromNow()
    },
    getMessage () {
      this.$fetch({
        methods: 'GET',
        url: '/video/allXiaoChengXuInterplay',
        params: {
          id: this.id,
          pageNum: this.pageNum,
          pageSize: 8
        }
      })
        .then(response => {
          // console.log(response)
          if (response.code === 0) {
            this.messageList = this.messageList.concat(response.data)
            this.loading = false
            if (response.data.length === 0) {
              this.finished = true
            }
          }
        })
    },
    imgError () {
      this.$toast('生成失败')
      this.$toast.clear()
      this.pic = ''
    },
    imgLoad () {
      setTimeout(() => {
        this.createPoster()
      }, 450)
    },
    getcode () {
      if (this.pic) {
        // ImagePreview({
        //   images: [
        //     this.pic
        //   ],
        //   closeable: true,
        //   showIndex: false
        // })
        this.showPicture = true
        this.$toast.clear()
        return
      }
      return this.$fetch({
        methods: 'GET',
        url: '/video/appletCode',
        params: {
          path: DETAIL_PAGE_PATH,
          scene: this.id,
          width: 218
        }
      })
        .then(response => {
          // console.log(response)
          if (response.code === 0) {
            this.wechatCode = API_PATH + response.data
          }
        })
    },
    createPoster () {
      // 生成海报
      const vm = this
      const domObj = document.getElementById('posterHtml')
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true
      }).then(function (canvas) {
        setTimeout(() => {
          vm.pic = canvas.toDataURL('image/png')
          // ImagePreview({
          //   images: [
          //     vm.pic
          //   ],
          //   closeable: true,
          //   showIndex: false
          // })
          vm.showPicture = true
          vm.$toast.clear()
        }, 300)
        // 在微信里,可长按保存或转发
      }).catch(() => {
        vm.$toast('生成失败')
        vm.$toast.clear()
      })
    },
    showImage (event) {
      console.log(event.target.src)
      if (event.target.nodeName === 'IMG') {
        ImagePreview({
          images: [
            event.target.src
          ],
          closeable: true,
          showIndex: false
        })
      }
    },
    touchstart (e) {
      console.log(e.timeStamp)
      this.tabStartTime = e.timeStamp
    },
    touchend (e) {
      this.tabEndTime = e.timeStamp
      console.log(e.timeStamp)
    },
    tabClick () {
      if (this.tabEndTime - this.tabStartTime < 350) {
        this.showPicture = false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.container, .player
  width 100%
  height 225px
.cover
  width 100%
  height 225PX
  position relative
  img
    width 100%
    height 100%
.count-down
  position absolute
  bottom 20px
  left 20px
.live
  padding 20px
.title
  font-size 15px
  color #333333
  line-height 24px
  font-weight 800
  width 100%
  height 55px
  padding 3px 8px
  word-break break-all
  box-sizing border-box
  display flex
  align-items center
  overflow hidden
  span
    display -webkit-box
    text-overflow ellipsis
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    overflow hidden
.share
  display flex
  justify-content space-around
  align-items center
  &>div
    border 1px solid #E3E3E3
    border-radius 22px
    display inline-block
    height 34px
    line-height 34px
    padding 0 10px
    font-size 12px
    span
      display inline-block
      width 18px
      height 18px
      background-repeat no-repeat
      background-size 100%
      margin-right 10px
      vertical-align middle
    .share-collect
      background-image url('../assets/collect.png')
    .share-friend-circle
      background-image url('../assets/friend.png')
    .share-friend
      background-image url('../assets/wechat.png')
  .collect
    width 85px
    padding 0 0 0 10px
.video-info
  display -webkit-box
  text-overflow ellipsis
  -webkit-line-clamp 2
  -webkit-box-orient vertical
  color #666666
  font-size 14px
  line-height 22px
  margin 15px 15px
  overflow hidden
.detail-info
  background-color #ffffff
  color #333
  font-size 14px
  margin 10px
  line-height 32px
  padding 15px
.c-detail
  border-radius 8px
  padding 10px
  background-color #ffffff
  margin 10px
  display flex
  justify-content flex-start
  .c-pic
    background-color #eeeeee
    height 30px
    width 30px
    border-radius 50%
    margin-right 10px
  .c-info
    color #333
    font-size 14px
    line-height 22px
    width 100%
  .c-name
    display flex
    justify-content space-between
    align-items center
  .c-time
    color #B4B5B6
    font-size 12px
.live-box
  margin 10px
  .live-content
    padding 15px
    background-color #ffffff
    border-radius 4px
    word-break break-word
.steps
  background-color #F5F5F6
  padding 0 0 0 35px
.live-time
  color #999999
  font-size 14px
  margin-bottom 10px
.live-detail
  color #333
  font-size 14px
  line-height 24px
.send-box
  position fixed
  bottom 0
  height 50px
  background-color #efefef
  width 100%
  display flex
  align-items center
  padding 0 15px
  box-shadow 0px -3px 6px rgba(51, 51, 51, 0.2)
  input
    width 260px
    height 34px
    line-height 34px
    font-size 13px
    background rgba(255, 255, 255, 1)
    border-radius 2px
    border none
    color #333
    padding 0 10px
    margin-right 15px
  span
    width 68px
    height 34px
    line-height 34px
    text-align center
    background rgba(252, 155, 24, 1)
    border-radius 4px
    color #ffffff
    font-size 16px
.post
  width 100%
  background #fff
  z-index 99999
  box-shadow 0px 2px 9px 0px rgba(0, 0, 0, 0.11)
  border-radius 5PX
  .p-pic
    img
      width 100%
      max-height 150px
      border-radius 5PX
      &.p-pic-big
        max-height 205px
  h3
    color #000
    font-size 15px
    margin 0
    padding 0
    margin-top 18px
    overflow hidden
  .p-info
    display flex
    .p-des
      color #666
      font-size 13px
      line-height 20px
      margin 20px 0 20px 0
      width 100%
      &.p-des-big
        margin 25px 0 30px 0
  .p-code
    width 100%
    padding 30px 0
    border-top 0.5px solid #EBEBEB
    display flex
    justify-content space-around
    align-items center
    &.p-code-big
      padding 40px 0
    img
      height 108px
      border none
    div
      margin-left -20px
      p
        color #666
        font-size 13px
        line-height 24px
      .p-text
        color #000
        text-align left
        font-weight 600
.van-tabs
  position absolute
  top calc(225PX + 100px)
  bottom 0
  width 100%
  left 0
  right 0
  overflow hidden
.try-btn
  z-index 9999
  position fixed
  top 54PX
  left 30PX
  background url('https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/img/bigplay.png') no-repeat // g.alicdn.com/de/prismplayer/2.8.2/skins/default/img/bigplay.png) no-repeat;
  background-size contain
  width 64px
  height 64px
  .count
    border 7px solid rgba(255, 255, 255, 0.51)
    width 64px
    height 64px
    border-radius 100%
    position absolute
    box-sizing border-box
    top 0
    left 0
.scroll-box
  padding-bottom 60px
.img-bg
  width 100%
  position fixed
  top 0
  right 2000px
  height calc(100% - 50px)
  background url('../assets/bg.png') no-repeat
  background-size cover
  padding 25px
  display flex
  align-items center
  z-index 999999
.p-content
  background-color #fff
  border-radius 5PX
  padding 0 30px
.picture-view
  position fixed
  top 0
  left 0
  right 0
  z-index 999999
  bottom 0
  background-color #fff
  img
    -webkit-touch-callout none
    -webkit-user-select none
.picture-tip
  background-color #fff
  span
    display inline-block
    margin-top 5px
    height 45px
    font-size 14px
    color #fff
    background linear-gradient(198deg, rgba(255, 109, 0, 1) 0%, rgba(253, 166, 0, 1) 100%)
    line-height 40px
    text-align center
    width 100%
.close-btn
  position fixed
  top 20px
  right 20px
  z-index 9999
  width 20px
  height 20px
  background url('../assets/close.png') no-repeat
  background-size contain
</style>
<style>
.van-step__circle{
  width:11px!important;
  height:11px!important;
  background-color:rgba(252,155,24,1)!important;
}
.van-tabs__content{
  height: 100%;
  overflow: scroll;
  background-color: #eeeeee;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.prism-player .prism-cover{
  background-size: 100% 100%
}
.prism-player .prism-progress-hover{
  height: 4px;
  bottom: 37PX!important;
}
</style>
